import { render, staticRenderFns } from "./XDropdown.vue?vue&type=template&id=110ecc1b&scoped=true"
import script from "./XDropdown.vue?vue&type=script&lang=js"
export * from "./XDropdown.vue?vue&type=script&lang=js"
import style0 from "./XDropdown.vue?vue&type=style&index=0&id=110ecc1b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "110ecc1b",
  null
  
)

export default component.exports